import { ValueOfKey } from '../../utils-types';

export const CHALLENGE_BANNER_UPLOAD_TYPE = {
  WEB: 'CHALLENGE_BANNER_WEB',
  MOBILE: 'CHALLENGE_BANNER_MOBILE',
} as const;

export type ChallengeBannerUploadType = ValueOfKey<typeof CHALLENGE_BANNER_UPLOAD_TYPE>;
